import { useQuery } from '@tanstack/react-query';
import { authedPost } from '@/lib/api';

// Hono backend base for chart-of-accounts writes (mirrors useChartOfAccounts.ts).
const BASE = '/api/v1/chart-of-accounts';

/**
 * Lazily fetches (or creates) the suspense account for an organization.
 *
 * Routed through the Hono backend: get_or_create_suspense_account is SECURITY
 * INVOKER and can INSERT into chart_of_accounts, which is backend-only
 * (RESTRICTIVE verify_backend_token() INSERT policy). The org-creation trigger
 * already seeds a suspense account, so this is almost always an early-return —
 * but routing through the backend attaches the HMAC so the rare real INSERT
 * (a legacy org missing one) still passes RLS.
 */
export function useSuspenseAccount(organizationId: string | undefined) {
  return useQuery({
    queryKey: ['suspense-account', organizationId],
    queryFn: async () => {
      const { accountId } = await authedPost<{ accountId: string }>(
        `${BASE}/orgs/${organizationId}/suspense-account`,
        {},
      );
      return accountId;
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
